<template>
    <rkm-modal
        extra-large
        ref="RkmModal"
        title="Solicitação de exame de imagem"
    >
        <rkm-row>
            <rkm-col>
                <rkm-form
                    ref="RkmFormExame"
                    show-legend
                >
                    <rkm-row>
                        <rkm-col>
                            <rkm-form-input-autocomplete
                                :repository="repositories.exame"
                                :request-query-string-params="requestQueryStringParams"
                                :search-fields="fields.autocomplete.exame"
                                :text-field="(item) => `${formatProcedimento(item.codigo)} - ${item.nome}`"
                                :validations="validations.exame"
                                label="Exame"
                                v-model="model.exame"
                            />
                        </rkm-col>

                        <rkm-col cols="auto">
                            <rkm-button
                                :label="false"
                                @click="include"
                                color="primary"
                            >
                                Incluir
                            </rkm-button>
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col>
                            <rkm-table
                                :fields="fields.table"
                                :items="model.exames"
                                hide-filters
                                hide-pagination
                            >
                                <template v-slot:cell(exame)="{item}">
                                    {{`${formatProcedimento(item.codigo)} - ${item.nome}`}}
                                </template>

                                <template v-slot:cell(actions)="{index}">
                                    <rkm-button
                                        @click="destroy(index)"
                                        color="danger"
                                        small
                                        title="Excluir"
                                    >
                                        <rkm-icon icon="trash" />
                                    </rkm-button>
                                </template>
                            </rkm-table>
                        </rkm-col>
                    </rkm-row>
                </rkm-form>

                <rkm-form ref="RkmForm">
                    <rkm-row class="mt-2">
                        <rkm-col>
                            <rkm-form-input-autocomplete
                                :repository="repositories.geral.ciap"
                                :request-query-string-params="{
                                    sexo_id: data.additionals.paciente.sexoId,
                                    show_all: true,
                                }"
                                :search-fields="fields.autocomplete.ciap"
                                :text-field="(item) => `${item.codigo} - ${item.descricao}`"
                                @select="handleCiapSelect"
                                label="CIAP 2"
                                v-model="model.ciap"
                            />
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>

                        <rkm-col cols="12" v-if="!model.sugestao">
                            <rkm-form-input-autocomplete
                                :repository="repositories.cid"
                                :request-query-string-params="{
                                    ciap_id: model.ciap ? model.ciap.id : null,
                                    sexo: data.additionals.paciente.sexoIdentificador,
                                }"
                                :results-limit= "20"
                                :search-fields="fields.autocomplete.cid"
                                :text-field="(item) => `${item.codigo} - ${item.nome}`"
                                label="CID 10"
                                v-model="model.cid"
                            >

                                <rkm-input-group-append slot="append">
                                    <rkm-input-group-text>
                                        <rkm-form-radio-group
                                            v-model="model.sugestao"
                                            :disabled="data.cidSugestao.length === 0"
                                        >
                                            <rkm-form-radio :value="true">Sugestão</rkm-form-radio>
                                            <rkm-form-radio :value="false">Novo</rkm-form-radio>
                                        </rkm-form-radio-group>
                                    </rkm-input-group-text>
                                </rkm-input-group-append>
                            </rkm-form-input-autocomplete>
                        </rkm-col>

                        <rkm-col cols="12" v-else>
                            <rkm-form-select
                                :options="data.cidSugestao"
                                label="CID 10"
                                show-default-option
                                text-field="codigoNome"
                                v-model="model.cidId"
                                value-field="id"
                            >

                                <rkm-input-group-append slot="append">
                                    <rkm-input-group-text>
                                        <rkm-form-radio-group v-model="model.sugestao">
                                            <rkm-form-radio :value="true">Sugestão</rkm-form-radio>
                                            <rkm-form-radio :value="false">Novo</rkm-form-radio>
                                        </rkm-form-radio-group>
                                    </rkm-input-group-text>
                                </rkm-input-group-append>
                            </rkm-form-select>
                        </rkm-col>
                    </rkm-row>

                    <BoxClassificacaoRisco :data="classificacaoRiscoData" :encaminhamento="true" />

                    <BoxAntropometria
                        :data="{form: data.objetivoForm, model: data.objetivoModel}"
                        :hidden-fields="['perimetroPanturrilha', 'perimetroCefalico', 'imc']"
                        :required="model.exames.some(exame => exame.exigirPesoAlturaCircunferencia)"
                    />

                    <rkm-row>
                        <rkm-col>
                            <rkm-form-textarea
                                :validations="validations.justificativa"
                                label="Justificativa do procedimento"
                                rows="8"
                                v-model="model.justificativa"
                                maxlength="290"
                            />
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col>
                            <rkm-form-textarea
                                :validations="validations.observacao"
                                label="Observações"
                                rows="4"
                                v-model="model.observacao"
                                maxlength="1500"
                            />
                        </rkm-col>
                    </rkm-row>
                </rkm-form>
            </rkm-col>
        </rkm-row>

        <template v-slot:footer="{cancel}">
            <rkm-button @click="cancel">
                Fechar
            </rkm-button>

            <rkm-button
                @click="save"
                color="primary"
            >
                {{item ? 'Salvar' : 'Incluir'}}
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Components.
import BoxClassificacaoRisco from '@/components/ambulatorio/components/classificacao-risco/Index'
import BoxAntropometria from '@/components/ambulatorio/components/antropometria/Index'

// Enums.
import tipoExame from '@/enums/parametrizacao/tipoExame'

// Mixins.
import {formats, object, repository, stringCase} from '@/mixins'

// Vuex.
import {mapActions} from 'vuex'

export default {
    components: {BoxClassificacaoRisco, BoxAntropometria},
    computed: {
        requestQueryStringParams() {
            return {
                exige_procedimento: true,
                paciente_id: this.data.additionals.paciente.id,
                tipo_id: this.enums.tipoExame.EXAME_IMAGEM,
            }
        },
        validations() {
            return {
                exame: {required: true},
                justificativa: {
                    required: true,
                    max: 290,
                },
                observacao: {max: 1500},
            }
        },
        classificacaoRiscoData() {
            return {
                form: this.data.form.solicitacaoExameAltoCusto,
                model: this.model
            }
        }
    },
    created() {
        this.repositories = {
            atendimento: this.getConectaSusRepository('ambulatorio.atendimento'),
            cid: this.getConectaSusRepository('sigtap.cid'),
            exame: this.getConectaSusRepository('parametrizacao.exame'),
            geral: this.getConectaSusRepository('geral'),
        }
    },
    data: () => ({
        enums: {tipoExame},
        fields: {
            autocomplete: {
                cid: [
                    {key: 'codigo', searchable: true},
                    {key: 'nome', searchable: true},
                ],
                ciap: [
                    {key: 'geral_ciap.codigo', searchable: true},
                    {key: 'geral_ciap.descricao', searchable: true},
                ],
                exame: [
                    {key: 'parametrizacao_exame.codigo', searchable: true},
                    {key: 'parametrizacao_exame.nome', searchable: true},
                    {key: 'parametrizacao_procedimento.apelido', searchable: true},
                ],
            },
            table: [
                {key: 'exame', label: 'Exame', sortable: true},
                {class: 'col-min text-center', key: 'actions', label: 'Ações'},
            ],
        },
        item: null,
        model: {
            exame: null,
            cid: null,
            cidId: null,
            ciap: null,
            classificacaoRiscoId: null,
            justificativa: null,
            observacao: null,
            exames: [],
            sugestao: false,
        },
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        open(item = null) {

            this.item = item

            if (this.item) {
                this.edit()
            } else {
                this.create()
            }

            this.model.sugestao = this.data.cidSugestao.length > 0

            this.$refs.RkmModal.show()
        },
        create() {
            this.resetForm()
        },
        edit() {
            this.model = this.clone({
                cid: this.item.cid,
                cidId: this.data.cidSugestao.length > 0 ? this.item.cid.id : null,
                ciap: this.item.ciap,
                classificacaoRiscoId: this.item.classificacaoRiscoId,
                justificativa: this.item.justificativa,
                observacao: this.item.observacao,
                exames: this.item.exames,
                sugestao: false,
            })
        },
        include() {
            this.$refs.RkmFormExame.validate()
                .then(valid => {
                    if (valid === false) return

                    if (this.model.exames.find(exame => exame.id === this.model.exame.id)) {
                        this.showValidationNotification('O exame de média e alta complexidade já foi incluído.')
                        return
                    }

                    const request = {
                        pacienteId: this.data.additionals.paciente.id,
                        exameId: this.model.exame.id,
                    }

                    this.setLoading()

                    this.repositories.atendimento.exameDentroPrazoValidade(this.camelObjectKeysToSnakeRecursive(request))
                        .then(response => {
                            const include = () => {
                                this.model.exames.push({
                                    id: this.model.exame.id,
                                    codigo: this.model.exame.codigo,
                                    nome: this.model.exame.nome,
                                    tipoId: this.model.exame.tipoId,
                                    complexidade: this.model.exame.complexidade,
                                    exigirPesoAlturaCircunferencia: this.model.exame.exigirPesoAlturaCircunferencia,
                                })

                                this.resetFormExame()
                            }

                            if (response.data) {

                                if (this.data.additionals.permiteExameImagemRepetido) {

                                    this.showWarningConfirmation(
                                        'Atenção',
                                        'O exame está dentro do prazo de validade. Deseja continuar?',
                                        async () => include(),
                                        async () => this.resetFormExame()
                                    )
                                } else {

                                    this.showAlert('O exame já está solicitado ao paciente e dentro do prazo de validade.', "Atenção");
                                }
                            } else {
                                include()
                            }
                        })
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading())
                })
        },
        destroy(index) {
            this.showDeleteConfirmation('Deseja realmente excluir o exame?', async () => {
                this.model.exames.splice(index, 1)
            })
        },
        resetFormExame() {
            this.model.exame = null
            this.$nextTick().then(() => this.$refs.RkmFormExame.resetValidator())
        },
        store() {

            let cid = null

            if (this.model.sugestao) {

                const cidSelecionado = this.data.cidSugestao.find(c => c.id == this.model.cidId)

                if (cidSelecionado) {

                    cid = {
                        id: cidSelecionado.id,
                        codigo: cidSelecionado.codigo,
                        nome: cidSelecionado.nome,
                    }
                }
            } else {

                cid = this.model.cid ? {
                    id: this.model.cid.id,
                    codigo: this.model.cid.codigo,
                    nome: this.model.cid.nome,
                } : null
            }

            this.data.model.solicitacoesExamesAltoCusto.push({
                cid: cid,
                ciap: this.model.ciap ? {
                    id: this.model.ciap.id,
                    codigo: this.model.ciap.codigo,
                    descricao: this.model.ciap.descricao,
                } : null,
                classificacaoRiscoId: this.model.classificacaoRiscoId,
                classificacaoRiscoDescricaoEncaminhamento: this.data.form.solicitacaoExameAltoCusto.classificacoesRisco
                    .find(c => c.id === this.model.classificacaoRiscoId).descricaoEncaminhamento,
                justificativa: this.model.justificativa,
                observacao: this.model.observacao,
                exames: this.model.exames,
            })
        },
        update() {

            let cid = null

            if (this.model.sugestao) {

                const cidSelecionado = this.data.cidSugestao.find(c => c.id == this.model.cidId)

                if (cidSelecionado) {

                    cid = {
                        id: cidSelecionado.id,
                        codigo: cidSelecionado.codigo,
                        nome: cidSelecionado.nome,
                    }
                }
            } else {

                cid = this.model.cid ? {
                    id: this.model.cid.id,
                    codigo: this.model.cid.codigo,
                    nome: this.model.cid.nome,
                } : null
            }

            Object.assign(this.item, {
                cid: cid,
                ciap: this.model.ciap ? {
                    id: this.model.ciap.id,
                    codigo: this.model.ciap.codigo,
                    descricao: this.model.ciap.descricao,
                } : null,
                classificacaoRiscoId: this.model.classificacaoRiscoId,
                classificacaoRiscoDescricaoEncaminhamento: this.data.form.solicitacaoExameAltoCusto.classificacoesRisco
                    .find(c => c.id === this.model.classificacaoRiscoId).descricaoEncaminhamento,
                justificativa: this.model.justificativa,
                observacao: this.model.observacao,
                exames: this.model.exames,
            })
        },
        save() {
            this.$refs.RkmForm.validate()
                .then(valid => {
                    if (valid === false) return

                    this.validateCidCiap()
                    if (this.errorCidCiap) {
                        this.createNotification({
                            type: 'alert',
                            color: 'danger',
                            title: 'Ação não permitida',
                            message: this.errorCidCiap
                        })
                    } else if (this.model.exames.length === 0) {
                        this.createNotification({
                            type: 'alert',
                            color: 'danger',
                            title: 'Ação não permitida',
                            message: 'É necessário incluir ao menos um exame para realizar a solicitação.'
                        })
                    } else {
                        if (this.item) {
                            this.update()
                        } else {
                            this.store()
                        }

                        this.$refs.RkmModal.hide()
                    }
                })
        },
        resetForm() {
            this.model.exame = null
            this.model.cid = null
            this.model.cidId = null
            this.model.ciap = null
            this.model.classificacaoRiscoId = null
            this.model.justificativa = null
            this.model.observacao = null
            this.model.exames = []
            this.model.sugestao = false
        },
        validateCidCiap() {
            this.errorCidCiap = ''

            if (!this.model.cid && !this.model.cidId && !this.model.ciap) {
                this.errorCidCiap = 'Deve ser preenchido o campo CID e/ou o campo CIAP'
            }
        },
        handleKitExameChange(value, kit) {
            if (value === true) {
                kit.exames.forEach(exame => {
                    if (!this.model.exames.find(e => e.id === exame.id)) {
                        this.model.exames.push(exame)
                    }
                })
            } else {
                kit.exames.forEach(exame => this.model.exames.splice(this.model.exames.findIndex(e => e.id === exame.id), 1))
            }
        },
        handleCiapSelect(value) {
            if (value.cidId) {
                this.model.cid = {
                    id: value.cidId,
                    codigo: value.cidCodigo,
                    nome: value.cidNome,
                }

                this.model.sugestao = false
            }
        },
    },
    mixins: [formats, object, repository, stringCase],
    props: {
        data: {required: true, type: Object},
    },
}
</script>